export default __webpack_public_path__ + "static/media/vc_img.5acee2d4.svg";